var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ks_box"},[_c('div',{staticClass:"lt ksborder"}),_c('div',{staticClass:"rt ksborder"}),_c('div',{staticClass:"lb ksborder"}),_c('div',{staticClass:"rb ksborder"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }